var map = {
	"./pin_09A129.svg": 82063,
	"./pin_6C7AE0.svg": 38993,
	"./pin_707070.svg": 85014,
	"./pin_AB810A.svg": 33782,
	"./pin_B3261E.svg": 73700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14723;